import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export class BulletinWidget extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            caller: props.Caller,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/dashboard/widget/get", { name: 'BulletinWidget' })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false,
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div>
            {
                this.state.data.records.length <= 0 ?
                    <p className="alert alert-fill alert-warning alert-icon text-center">در حال حاضر خبری در بولتن شما ثبت نشده است</p>
                    : <ul>
                        {this.state.data.records.map(record =>
                            <li className="col-lg-12 col-12 col-sm-12 no-drag-widget" id={record.id}>
                                <a className="hand" onClick={e => this.state.caller.showBulletin(record.id)}>{record.title}</a>
                                <small>({record.addDateString})</small>
                            </li>
                        )}
                    </ul>
            }
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.renderForm(),
            ];

        return contents;
    }
}